<template>
    <b-modal id="myPromisGoodsSearch" :title="title" size="md" @show="fn_search">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control" v-model="myPromiseGoodsNm">
                    <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
                </li>
              <li v-show="filter">
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" checked>
                  <label for="radio1">전체</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio">
                  <label for="radio2">기준재고량 미달</label>
                </div>
              </li>
            </ul>
            <div class="modal_table">
                <table class="list">
                    <colgroup>
                        <col width="50">
                        <col width="50">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>내약속상품명</th>
                            <th>제조수량</th>
                            <th>설명</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in myPromiseGoodsList" :key="index">
                        <td>
                            <div class="form_checkbox">
                                <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="checkBox" :value="index" @change="fn_check">
                                <label :for="'checkbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ index + 1 }}</span></td>
                        <td><span>{{ item.my_promise_goods_nm }}</span></td>
                        <td><span>{{ item.produce_quantity }}</span></td>
                        <td><span>{{ item.my_promise_goods_source }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">        
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'

    export default {
        name: 'myPromisGoodsSearch',
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            searchName: String,
            searchData: String,
            oneBtn: Boolean,
            filter: Boolean,
        },
        data() {
            return {
                checkBox : [],
                myPromiseGoodsList : [],
                myPromiseGoodsmedList : [],
                myPromiseGoodsNm : this.searchData
            }
        },
        methods : {
            fn_search(){

                let param = new Object();
                param.myPromiseGoodsNm = this.myPromiseGoodsNm;

                console.log("@@@@ param : %o",param);

                axios
                    .post("/api/admin/promiseGoodsWrhs/searchModalPromiseGoods", param)
                    .then((res) => {
                        console.log("@@@@ dtl res : %o",res);
                        this.myPromiseGoodsList = res.data.myPromiseGoodsList;
                    })
                    .catch((err) => console.log(err));
                
            },
            fn_apply(){
                               
                if(this.checkBox.length == 0){
                    alert("체크된 약속상품이 없습니다.");
                }else if(this.checkBox.length > 1){
                    alert("한개 이상 선택할수 없습니다.");
                }else{                    
                    
                    console.log("@@@@@ checkBox : %o",this.checkBox[0]);

                    let medObject = this.myPromiseGoodsList[this.checkBox[0]];

                    console.log("@@@@@ medObject : %o",medObject);
                    
                     axios
                    .post("/api/admin/promiseGoodsWrhs/searchPromiseGoodsMedcine", medObject)
                    .then((res) => {
                        
                        this.myPromiseGoodsmedList = res.data.myPromiseGoodsmedList;

                        this.$emit('callback', this.myPromiseGoodsmedList, medObject.produce_quantity);

                    })
                    .catch((err) => console.log(err));




                    this.fn_init();
                    this.$bvModal.hide('myPromisGoodsSearch');
                }                                        
            },
            fn_init(){
                this.myPromiseGoodsmedList = [];
                this.medicineList = [];
                this.checkBox = [];
                this.medHubNm = '';
            },
            fn_check(){
                if(this.checkBox.length > 1){
                    this.checkBox.splice(0,1);
                }
            }
        }
    }
</script>
